import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Header.css';

const Header = () => {
  const [cartCount] = useState(0);

  return (
    <header className="header">
      <div className="header__container">
        <nav className="header__nav">
          <Link to="/under-construction" className="header__nav-link">current editions</Link>
          <Link to="/under-construction" className="header__nav-link">permanent</Link>
          <Link to="/under-construction" className="header__nav-link">archive</Link>
          <Link to="/under-construction" className="header__nav-link">object</Link>
          <Link to="/under-construction" className="header__nav-link">notes</Link>
          <Link to="/under-construction" className="header__nav-link">visit</Link>
        </nav>

        <div className="header__right">
          <Link to="/under-construction" className="header__cart-btn" aria-label="Cart">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path d="M3 3H17L16 13H4L3 3Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/>
              <path d="M7 17.5C7 18.3284 6.32843 19 5.5 19C4.67157 19 4 18.3284 4 17.5C4 16.6716 4.67157 16 5.5 16C6.32843 16 7 16.6716 7 17.5Z" fill="currentColor"/>
              <path d="M16 17.5C16 18.3284 15.3284 19 14.5 19C13.6716 19 13 18.3284 13 17.5C13 16.6716 13.6716 16 14.5 16C15.3284 16 16 16.6716 16 17.5Z" fill="currentColor"/>
            </svg>
            {cartCount > 0 && <span className="header__cart-count">{cartCount}</span>}
          </Link>
        </div>
      </div>
    </header>
  );
};

export default Header;
